import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../stores/auth';
import { ThemeToggle } from '../../components/ui/ThemeToggle';
import '../dashboard/dashboard.css';

export function AdminLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="dash-page">
        <p className="dash-page-subtitle">Checking permissions…</p>
      </div>
    );
  }

  if (!user || user.role !== 'operator') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="dash-shell">
      <aside className="dash-sidebar" style={{ width: '14rem' }}>
        <div className="dash-sidebar__header">
          <span className="dash-logo">
            <span className="dash-logo__mark" aria-hidden="true">◐</span>
            <span>Sarnia Builder</span>
          </span>
        </div>
        <nav className="dash-nav" aria-label="Admin">
          <NavLink
            to="/admin/users"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
          >
            Users
          </NavLink>
          <NavLink
            to="/admin/sites"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
          >
            Sites
          </NavLink>
          <NavLink
            to="/admin/requests"
            className={({ isActive }) => `dash-nav__link${isActive ? ' dash-nav__link--active' : ''}`}
          >
            Plan requests
          </NavLink>
        </nav>
        <div className="dash-sidebar__footer">
          <span className="dash-user-email">{user.email}</span>
        </div>
      </aside>
      <div className="dash-main">
        <header className="dash-topbar">
          <div className="dash-topbar__title">Operator admin</div>
          <div className="dash-topbar__actions">
            <ThemeToggle />
          </div>
        </header>
        <main className="dash-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
